import React from 'react';
import styles from '@/styles/components/sendable-survey-stack/SendableSurveyItem.module.css';
import { TimestampMark } from 'components/TimestampMark';

export interface SendableSurveyItemData {
  name: string;
  createdAt: Date;
  updatedAt: Date;
  onClick: () => void;
}
export const SendableSurveyItem: React.FC<SendableSurveyItemData> = props => {
  return (
    <div className={`${styles.itemContainer}`} onClick={props.onClick}>
      <div className={styles.infoContainer}>
        <label className={styles.nameLabel}>{props.name}</label>
      </div>
      <div className={styles.contentContainer}>
        <TimestampMark
          createdAt={props.createdAt}
          modifiedAt={props.updatedAt}
        />
      </div>
    </div>
  );
};
